import { useTranslation } from "react-i18next";
import type { PositionChange } from "../hooks/useRankingTrends";

interface PositionBadgeProps {
  change: PositionChange;
}

const PositionBadge = ({ change }: PositionBadgeProps) => {
  const { t } = useTranslation();

  if (change === "new") {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-bold bg-blue-100 text-blue-700">
        {t("statsNew.classement.trend.new")}
      </span>
    );
  }

  if (change === "same" || change === 0) {
    return <span className="text-gray-400 text-sm">{t("statsNew.classement.trend.noChange")}</span>;
  }

  const isPositive = change > 0;

  return (
    <span
      className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded text-xs font-semibold ${
        isPositive ? "bg-green-50 text-green-600" : "bg-red-50 text-red-600"
      }`}
    >
      {isPositive ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-3 w-3"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-3 w-3"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      )}
      <span>{Math.abs(change)}</span>
    </span>
  );
};

export default PositionBadge;
